import styled from 'styled-components'

// Wrapper
// ============================================================
export const RadarGraphStyle = styled.div`
  /* Parent
  ------------------------------- */
  /* Childrens
  ------------------------------- */
  .recharts-polar-radius-axis-ticks {
    .recharts-polar-radius-axis-tick {
      .recharts-polar-radius-axis-tick-value {
        transform: translate(-15px, 7px);
        fill: black;
      }
    }
  }

  /* Modifiers
  ------------------------------- */
  /* Media queries
  ------------------------------- */
`
